import { toAppUrl } from "src/services/configService";

export async function loadOssLicenses(): Promise<string> {
    // rollup-plugin-license writes THIRD-PARTY-LICENSES.txt into dist/assets/ during build (see vite.config.mts).
    const response = await fetch(toAppUrl("assets/THIRD-PARTY-LICENSES.txt"));

    // A missing file on the static host falls back to index.html (HTTP 200, text/html). Guard
    // against that so the page shows its error state instead of rendering raw HTML markup.
    const contentType = response.headers.get("content-type") ?? "";
    if (!response.ok || !contentType.includes("text/plain")) {
        throw new Error(`Failed to load OSS licenses (status ${response.status}, content-type "${contentType}")`);
    }

    return response.text();
}
